import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import { getAllPortarit } from '@blade-sxp/task-management/api/creat-task/index';
let default_1 = class default_1 extends Vue {
    id;
    disabled;
    filterable;
    formData = {
        id: this.$props.id,
    };
    options = [];
    mounted() {
        getAllPortarit().then(({ list }) => {
            if (list) {
                this.options = list;
            }
        });
    }
    get rules() {
        return {
            id: [{ required: true, message: this.$t('placeholder'), trigger: 'blur' }],
        };
    }
    changeId(val) {
        this.$emit('update:id', val);
    }
    isValidate() {
        let isValidate = null;
        this.$refs.ruleForm.validate((valid) => {
            if (valid) {
                isValidate = true;
            }
            else {
                isValidate = false;
            }
        });
        return isValidate;
    }
};
__decorate([
    Prop()
], default_1.prototype, "id", void 0);
__decorate([
    Prop({ default: false, type: Boolean })
], default_1.prototype, "disabled", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], default_1.prototype, "filterable", void 0);
default_1 = __decorate([
    Component({
        name: 'Portrait',
        components: {},
        i18n: {
            messages: {
                zh: {
                    title: '人像库',
                    placeholder: '请选择',
                },
                'en-us': {
                    title: 'Portrait Libary',
                    placeholder: 'Please select',
                },
            },
        },
    })
], default_1);
export default default_1;
